<template>
  <v-app id="duorol-page">
    <Menu />
    <v-container id="duorol" grid-list-lg>
     
        <v-layout row wrap>

          <!-- Afmetingen Block -->
          <v-flex xs12>
            <v-form ref="form1" @submit.prevent="goToStep(2, 1)">
              <v-card class="card-expansion" :disabled="true">
                <v-toolbar @click="toggleStep(1)" :class="{ 'elevation-0': true, 'panel-open': step1, 'product-panel': !step1 }">
                  <img :src="step1 ? require('../assets/ui-elements/step1-active.png') : require('../assets/ui-elements/step1.png')" alt="">
                  <v-card-title dark> <span :class="{ 'sub-title': true, 'step-tile-active': step1, 'step-title': !step1 }">Afmetingen</span></v-card-title>
                  <v-spacer></v-spacer>
                  <h4 class="mr-5 text-truncate activeProductTitle">B {{width}} x H {{height}} mm</h4>
                  <v-icon :class="{ 'step-icon-active': step1 }">{{ toggleIcon(step1) }}</v-icon>
                </v-toolbar>
                <transition name="expand">
                  <v-card-text v-if="step1">
                    <v-container grid-list-xs>
                      <v-layout row wrap>

                        <!-- afbeelding -->
                        <v-flex text-xs-center text-xs-center text-md-left xs12 md4 :class="{ 'pl-5': $vuetify.breakpoint.smAndDown, 'mb-5': $vuetify.breakpoint.xs }">
                          <img height="150px" :src="require('../assets/gordijn_afmetingen.png')" />
                        </v-flex>

                        <!-- breedte -->
                        <v-flex class="size-unit" text-xs-center xs12 md4 :class="{'mb-3': $vuetify.breakpoint.smAndDown, 'mt-3': $vuetify.breakpoint.mdAndUp, 'mt-5': $vuetify.breakpoint.lgAndUp }">
                          <span class="info-height mr-2">Breedte</span>
                          <div class="sizeRange">
                            <v-text-field outline v-model="width" :rules="widthRules" @change="updatePrice()" placeholder="250 tot 2750mm" validate-on-blur type="number"></v-text-field>
                          </div> <span class="ml-2 info-height hidden-md-only">mm</span>
                        </v-flex>

                        <!-- hoogte -->
                        <v-flex class="size-unit" text-xs-center xs12 md4 :class="{'mb-3': $vuetify.breakpoint.smAndDown, 'mt-3': $vuetify.breakpoint.mdAndUp, 'mt-5': $vuetify.breakpoint.lgAndUp }">
                          <span class="info-height mr-2">Hoogte</span>
                          <div class="sizeRange">
                            <v-text-field outline v-model="height" :rules="heightRules" @change="updatePrice()" placeholder="250 tot 2800mm" validate-on-blur type="number"></v-text-field>
                          </div> <span class="ml-2 info-height hidden-md-only">mm</span>
                        </v-flex>

                        <v-flex xs12 text-xs-center text-md-left class="mt-4">
                              <div>Let op: alle maten invullen in milimeters.</div>
                        </v-flex>
                      
                        <v-flex xs12 text-xs-right>
                          <v-btn type="submit" @click="updatePrice()" class="next-step text-none" color="primary" flat outline>Volgende
                            stap <v-icon right>fal fa-chevron-right</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </transition>
              </v-card>
            </v-form>
          </v-flex>

          <!-- Totaal Block -->
          <v-flex xs12>
             <v-form @submit.prevent="addToCart()" ref="form2">
            <v-card class="card-expansion" :disabled="true">
              <v-toolbar @click="toggleStep(2)" class='elevation-0' :class="{ 'elevation-0': true, 'panel-open': step2, 'product-panel': !step2 }">
                <img :src="step2 ? require('../assets/ui-elements/step2-active.png') : require('../assets/ui-elements/step2.png')" alt="">
                <v-card-title dark> <span :class="{ 'sub-title': true, 'step-tile-active': step2, 'step-title': !step2 }">Totaal</span></v-card-title>
                <v-spacer></v-spacer>
                <h4 class="mr-5 text-truncate activeProductTitle">&#8364; {{ currency(price) }}</h4>
                <v-icon :class="{ 'step-icon-active': step2 }">{{ toggleIcon(step2) }}
                </v-icon>
              </v-toolbar>
              <transition name="expand">
                <v-card-text v-if="step2">
                  <v-container grid-list-xs>
                    <v-layout row wrap>

                      <!-- Afmetingen -->
                      <v-flex xs4 sm2 md2><span class="total-title">Afmeting:</span></v-flex>
                      <v-flex xs8 sm10 md10><span class="total-item">Breedte {{width}} mm x Hoogte
                          {{height}} mm </span></v-flex>

                      <!-- Ruimte/Raam + Totale Prijs & Button -->
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs4 sm2 md2><span class="total-title">Aantal</span></v-flex>
                          <v-flex xs6 sm10 md10>
                            <v-text-field class="quantity-input" v-model="quantity" type="number" min="1" outline></v-text-field>
                          </v-flex>
                          <v-flex xs4 sm2 md2>
                            <span class="total-title">Ruimte / raam</span>
                          </v-flex>
                          <v-flex xs8 sm8 md8>
                            <v-text-field class='price-input' v-model="room" type="text" outline
                              label="Typ hier een naam voor de ruimte of het raam">
                            </v-text-field>
                          </v-flex>
                          <v-flex text-xs-center xs12>
                            <hr class="seperator-line">
                          </v-flex>
                          <v-flex xs2 text-xs-left>
                            <span class="end-total-title">Totaal</span>
                          </v-flex>
                          <v-flex xs10 text-xs-right>
                            <h2 class="price-total"> <span class="price-title mr-3">Prijs compleet,
                                incl. BTW </span> € {{ currency(price) }}</h2>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </transition>
            </v-card>
            <v-flex id="col-btn" xs12 text-xs-right v-if="isValid && price">
              <v-btn type="submit" color="primary" depressed class="text-none form-btn">Plaats op lijst
                <v-icon class="icon-size" right>fal fa-plus</v-icon>
              </v-btn>
            </v-flex>
             </v-form>
          </v-flex>
        </v-layout>

    </v-container>
    <SnackBar v-model="snackbar" :text="messageTxt" :color="color" />
  </v-app>
</template>


<script>
import { ref, computed, watch, reactive, toRefs } from '@vue/composition-api'
import Menu from '@/components/Menu';
import Messages from '@/services/messages.service'; // Meldingen
import SnackBar from '@/components/SnackBar';
import ApiService from '@/services/api.service'; // Api Service
import FormatService from '@/services/format.service'; // Filters

export default {
  components: {
    Menu,
    SnackBar
  },
  setup(props, context) {

    const stepper = reactive({
      step1: true,
      step2: false,
    })

    const width = ref()
    const height = ref()

    const room = ref('')
    const quantity = ref(1)
    const unitPrice = ref(0)
    const price = computed(() => Number(quantity.value) * Number(unitPrice.value))
    const isValid = computed(() => width.value && height.value)

    function updatePrice() {
      if (isValid.value) {
        ApiService.getDuoRollPrice({
          width: width.value,
          height: height.value,
        }).then(data => {
          unitPrice.value = data.price
        })
      } else {
        unitPrice.value = 0
      }
    }

    // rules
    const widthRules = [
      value => !!value || 'Breedte is verplicht',
      value => Number(value) >= 250 || 'Minimale breedte is 250mm',
      value => Number(value) <= 2750 || `Maximale breedte is 2750mm`,
    ]

    const heightRules = [
      value => !!value || 'Hoogte is verplicht',
      value => Number(value) >= 250 || 'Minimale hoogte is 250mm',
      value => Number(value) <= 2800 || `Maximale hoogte is 2800mm`,
    ]

    // filters
    const { currency } = FormatService

    // snackbar
    const snackbar = ref(false)
    const messageTxt = ref('')
    const color = ref('')

    // functions
    function goToStep(step, fromStep) {
      if (fromStep && !context.refs[`form${fromStep}`].validate()) {
        return
      }

      Object.keys(stepper).forEach(key => {
        stepper[key] = key === `step${step}`
      })
    }

    function toggleStep(step) {
      let toggleStep = 'step' + step
      stepper[toggleStep] = !stepper[toggleStep]
    }

    function toggleIcon(value) {
      return value ? 'fal fa-minus-circle' : 'fal fa-plus-circle'
    }

    function addToCart() {
      context.root.$store.dispatch('products/addProduct', {
        type: 'duo-roll',
        name: context.root.$router.history.current.meta.title,
        width: width.value,
        height: height.value,
        quantity: quantity.value,
        room: room.value,
        unit_price: unitPrice.value,
        unit: 'stuks',
        price: price.value,
      })

      snackbar.value = true;
      color.value = '#006fb3';
      messageTxt.value = Messages.ProductAddedMessage;
    }


    return {
      ...toRefs(stepper),
      goToStep,
      toggleStep,
      toggleIcon,

      width,
      height,
      widthRules,
      heightRules,

      isValid,
      room,
      quantity,
      unitPrice,
      price,

      updatePrice,
      currency,
      addToCart,

      snackbar,
      messageTxt,
      color,

    }

  },
}
</script>



<style scoped>

#duorol-page {
    background-color: #fff;
}

.card-expansion {
    box-shadow: none;
    border: 1px solid #eaeaea;
}

.type-extra-title {
    color: #006fb3;
    font-size: 15px;
    font-weight: 700;
}

.min {
    padding: 0 !important;
    margin: 0 !important;
    position: relative;
    top: 0;
    left: 0;
    left: -5%;
    top: -15%;
    color: #b4b4b4;
    font-size: 12px;
    font-weight: 400;
}

.max {
    padding: 0 !important;
    margin: 0 !important;
    position: relative;
    clear: both;
    right: -55%;
    top: -34%;
    color: #b4b4b4;
    font-size: 12px;
    font-weight: 400;
}

.sizeRange {
    border-radius: 4px;
    display: inline-block;
    width: 220px;
    height: 60px;
    position: relative;
    top: -1em;
    padding: 1em;
    vertical-align: middle;
    line-height: 60px;
}

.info-height {
    color: #707070;
    font-size: 16px;
    font-weight: 400;
}

.size-unit {
    position: relative;
    /* top: -8em; */
    line-height: 30px;
    text-align: center;
}

.product-panel {
    border-top: 3px solid #b4b4b4;
    background-color: #fff;
}

.panel-open {
    border-top: 3px solid #006fb3;
    background-color: #fff;
}

.step-title {
    font-size: 15px;
    font-weight: 700;
    color: #b4b4b4;
}

.step-tile-active {
    font-size: 15px;
    font-weight: 700;
    color: #006fb3;
}

.step-icon-active {
    color: #006fb3;
}

.next-step {
    border-radius: 4px;
    height: 60px;
}

.activeProductTitle {
    color: #b4b4b4;
    font-size: 16px;
    font-weight: 400;
}

.product-tile {
    border: 1px solid #d0d0d0;
}

.product-tile-title {
    font-weight: 400;
    font-size: 19px;
    color: #707070;
}

.gordijnen-product-image {
    position: relative;
    right: 10px;
    width: 25%;
    height: 25%;
}

.selected {
    border: 2px solid #006fb3;
}

.plooi-selected {
    border: 2px solid #006fb3 !important;
}

.seperator-line {
    border: 1px solid #b4b4b4;
}


.total-title {
    color: #006fb3;
    font-size: 13px;
    font-weight: 700;
}

.price-title {
    color: #006fb3;
    font-size: 13px;
    font-weight: 700;
}


.total-item {
    color: #707070;
    font-size: 13px;
    font-weight: 400;
}

#addToCart {
    border-radius: 4px;
    height: 60px;
    margin: 0 !important;
}

.price-total {
    font-size: 15px;
    color: #006fb3;
    font-weight: 700;
}

.end-total-title {
    font-size: 15px;
    color: #006fb3;
    font-weight: 700;
}

.form-btn {
    border-radius: 4px;
    height: 60px;
    margin: 0 !important;
    width: 180px;
}

.icon-size {
    font-size: 20px;
}

#col-btn {
    padding-right: 0;
    padding-left: 0;
}

@media screen and (max-width: 1024px) {
    .plooi-product-image {
        width: 80%;
    }
}

@media screen and (max-width: 425px) {
    .size-unit {
        position: relative;
        top: -2.5em;
    }

    .form-btn {
        width: 100%;
    }

    #height-help {
        margin: 0 auto;
        text-align: center;
        justify-content: center;
    }

    .info-height {
        font-size: 13px;
    }

    .activeProductTitle {
        font-size: 14px;
    }

    #addToCart {
        width: 100%;
    }

}

@media screen and (max-width: 320px) {
    .size-unit {
        position: relative;
        top: -3em;
    }

    .activeProductTitle {
        display: none;
    }

}
</style>
